import { addMethod, string } from 'yup';

addMethod(string, 'email', function validateEmail(message) {
  return this.matches(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    {
      message,
      name: 'email',
      excludeEmptyString: true,
    }
  );
});
